import { useState } from 'react'
import { FullscreenOutlined, FullscreenExitOutlined } from '@ant-design/icons';

const FullScreen = () => {

    const [isFullscreen, setIsFullscreen] = useState(false);
    
    const toggleFullscreen = () => {
        if (!isFullscreen) {
            document.documentElement.requestFullscreen();
        } else {
            document.exitFullscreen();
        }
        setIsFullscreen(!isFullscreen);
    };

    return (
        <>
            <div className="fullscreen">
                <span onClick={toggleFullscreen} className="icon-button">
                    {isFullscreen ? <FullscreenExitOutlined /> : <FullscreenOutlined />}
                </span>
            </div>
        </>
    )
}

export default FullScreen